module.exports = __webpack_public_path__ + "static/img/4.b91759d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/4.png
// module id = 21RU
// module chunks = 0